import { useCallback, useEffect, useState } from 'react'
import type { ThemePreference } from '../../core/utils/theme'
import { applyThemePreference, getStoredThemePreference, setStoredThemePreference } from '../../core/utils/theme'

export function useThemePreference() {
  const [themePreference, setThemePreferenceState] = useState<ThemePreference>(() => getStoredThemePreference())

  useEffect(() => {
    applyThemePreference(themePreference)
  }, [themePreference])

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== 'theme_preference') return
      const next = getStoredThemePreference()
      setThemePreferenceState(next)
    }

    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setThemePreference = useCallback((next: ThemePreference) => {
    setStoredThemePreference(next)
    setThemePreferenceState(next)
    applyThemePreference(next)
  }, [])

  return { themePreference, setThemePreference }
}
